import React, { useEffect, useState, useMemo } from "react";
import axios from "axios";
import config from "../../config";
import LoginChecked from "../Shared/LoginChecked";
import ProductsDropDown from "../Shared/ProductsDropDown";
import dayjs from "dayjs";
import {
  Table,
  Row,
  Button,
  DatePicker,
  Form,
  Select,
  Col,
  Popconfirm,
  Tooltip,
  message,
} from "antd";
import { DeleteOutlined, PrinterOutlined } from "@ant-design/icons";
import { NavLink, useSearchParams } from "react-router-dom";
import BoxCard from "../Shared/BoxCard";

function Summary() {
  const { RangePicker } = DatePicker;
  const [searchParams] = useSearchParams();
  const AccessKey = localStorage.getItem("AccessKey");
  const UserID = localStorage.getItem("ID");
  const [loading, setLoading] = useState(false);
  const defaultEnd = dayjs().format("YYYY-MM-DD");
  const defaultStart = dayjs().subtract(30, "day").format("YYYY-MM-DD");
  const [StartDate, SetStartDate] = useState(defaultStart);
  const [EndDate, SetEndDate] = useState(defaultEnd);
  const [listofMachine, SetlistofMachine] = useState([]);
  const [PageSize, setPageSize] = useState(50);
  const [PageNo, setPageNo] = useState(1);
  const [ProductID, setProductID] = useState(0);
  const [refreshKey, setRefreshKey] = useState(0);
  const [data, setDate] = useState({});
  const [totalRecords, setTotalRecords] = useState(0);
  const ProductType = ProductsDropDown();

  const urlStartDate = searchParams.get("StartDate");
  const urlEndDate = searchParams.get("EndDate");

  useEffect(() => {
    if (urlStartDate) SetStartDate(urlStartDate);
    if (urlEndDate) SetEndDate(urlEndDate);
  }, [urlStartDate, urlEndDate]);

  useEffect(() => {
    document.title = "DIP Summary";
    if (!StartDate || !EndDate) {
      return;
    }
    setLoading(true);
    const payload = {
      UserID: UserID,
      AccessKey: AccessKey,
      StartDate: StartDate,
      EndDate: EndDate,
      PageNo: PageNo,
      PageSize: PageSize,
      ProductID: ProductID,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "Product/GetDIPSummary",
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code == 1) {
          SetlistofMachine(response.data.listofLedger);
          setDate(response.data);
          setTotalRecords(response.data.totalRecords ?? 0);
        }
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  }, [StartDate, EndDate, PageNo, PageSize, ProductID, refreshKey]);

  const handelDelete = (Dated) => {
    setLoading(true);

    const payload = {
      AccessKey: AccessKey,
      UserID: UserID,
      Dated: Dated,
    };

    var api_config = {
      method: "post",
      url: config.base_url + "Product/DeleteDIPRecord",
      headers: {
        "Content-Type": "application/json",
      },
      data: payload,
    };

    axios(api_config)
      .then(function (response) {
        if (response.data.status_code === 1) {
          message.success(response.data.status_message);
          setRefreshKey((k) => k + 1);
        } else {
          message.error(response.data.status_message);
        }
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
      });
  };

  const columns = [
    {
      title: "SR",
      dataIndex: "Sr",
      key: "Sr",
      render: (_, record, index) => index + 1 + PageSize * (PageNo - 1),
    },
    {
      title: "Dated",
      dataIndex: "Dated",
      key: "Dated",
      render: (date) => dayjs(date).format(config.date_format),
    },
    {
      title: "Product",
      dataIndex: "Name",
      key: "Product",
    },
    {
      title: "Physical (dip) stock (L)",
      dataIndex: "TotalPhysicalStock",
      key: "physical",
    },
    {
      title: "Book stock (L)",
      dataIndex: "TotalSystemStock",
      key: "book",
    },
    {
      title: "Difference (L)",
      dataIndex: "DifferenceQuantity",
      key: "Difference",
    },
    {
      title: "Adjustment Rate",
      dataIndex: "AdjustmentRate",
      key: "Adjustment Rate",
      align: "right",
    },
    {
      title: "Amount (Rs.)",
      dataIndex: "AdjustmentAmount",
      key: "Amount",
      align: "right",
    },

    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Popconfirm
          title="Delete all DIP for this date?"
          description="Removes every product's DIP posting for this calendar date (not only this row)."
          onConfirm={() => handelDelete(record.Dated)}
        >
          <Tooltip title="Delete DIP for this date">
            <DeleteOutlined />
          </Tooltip>
        </Popconfirm>
      ),
    },
  ];

  const handleDateChange = (dates) => {
    if (dates && dates[0] && dates[1]) {
      SetStartDate(dates[0].format("YYYY-MM-DD"));
      SetEndDate(dates[1].format("YYYY-MM-DD"));
      setPageNo(1);
    }
  };
  const disabledDate = (current) => {
    return current && current > dayjs().endOf("day");
  };

  const rangePickerValue = useMemo(() => {
    if (!StartDate || !EndDate) return null;
    const start = dayjs(StartDate, "YYYY-MM-DD", true);
    const end = dayjs(EndDate, "YYYY-MM-DD", true);
    if (!start.isValid() || !end.isValid()) return null;
    return [start, end];
  }, [StartDate, EndDate]);

  const printHref = `/dipsettings/printsummary?StartDate=${encodeURIComponent(
    StartDate || ""
  )}&EndDate=${encodeURIComponent(EndDate || "")}&ProductID=${ProductID}`;

  return (
    <>
      <LoginChecked />
      <div className="right-side-contents">
        <div className="page-content">
          <div className="page-header">
            <h3 className="page-title">DIP Summary</h3>

            <div className="header-actions">
              <NavLink to={printHref} target="_blank" rel="noopener noreferrer">
                <Button type="dashed" shape="round" size="large">
                  <PrinterOutlined />
                  Print Summary
                </Button>
              </NavLink>
            </div>
          </div>
          <div className="card-total-detal">
            <Row gutter={[16, 16]} style={{ marginBottom: "16px" }}>
              <Col md={6}>
                <BoxCard
                  loading={loading}
                  title="Total Gain"
                  amount={data?.totalGain}
                  prefix="Rs."
                  icon={
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      stroke="#32a844"
                      className="size-6"
                      viewBox="0 0 30 30"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m9 12.75 3 3m0 0 3-3m-3 3v-7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                      />
                    </svg>
                  }
                />
              </Col>
              <Col md={6}>
                <BoxCard
                  loading={loading}
                  title="Total Loss"
                  amount={
                    data?.totalLoss != null && data.totalLoss < 0
                      ? Math.abs(data.totalLoss)
                      : data?.totalLoss
                  }
                  prefix="Rs."
                  icon={
                    <svg
                      viewBox="0 0 30 30"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      stroke="#ff1c1c"
                      className="size-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="m15 11.25-3-3m0 0-3 3m3-3v7.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                      />
                    </svg>
                  }
                />
              </Col>
            </Row>
          </div>
          <div className="filters-wrap">
            <Form>
              <Form.Item>
                <RangePicker
                  onChange={handleDateChange}
                  disabledDate={disabledDate}
                  value={rangePickerValue}
                />
              </Form.Item>
              <Form.Item>
                <Select
                  showSearch
                  allowClear
                  style={{
                    width: "200px",
                  }}
                  placeholder="All products"
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                  value={ProductID === 0 ? undefined : ProductID}
                  onChange={(value) => {
                    setProductID(value === undefined ? 0 : value);
                    setPageNo(1);
                  }}
                  options={ProductType}
                />
              </Form.Item>
            </Form>
          </div>

          <Table
            size="small"
            rowKey="ID"
            scroll={{
              x: "100%",
            }}
            bordered
            loading={loading}
            columns={columns}
            dataSource={listofMachine}
            pagination={{
              current: PageNo,
              pageSize: PageSize,
              total: totalRecords,
              showSizeChanger: true,
              onChange: (page, size) => {
                setPageNo(page);
                setPageSize(size);
              },
            }}
          />
        </div>
      </div>
    </>
  );
}

export default Summary;
